import { temporarilyNotSupport } from '../../utils'

// 键盘
export const onKeyboardHeightChange = /* @__PURE__ */ temporarilyNotSupport('onKeyboardHeightChange')
export const offKeyboardHeightChange = /* @__PURE__ */ temporarilyNotSupport('offKeyboardHeightChange')
export const hideKeyboard = /* @__PURE__ */ temporarilyNotSupport('hideKeyboard')
export const getSelectedTextRange = /* @__PURE__ */ temporarilyNotSupport('getSelectedTextRange')
